// SETUP-REGROUP: a Setup page's (or a personal page's) one-line description, read from the
// catalog by the current path, so every page is explained in one place. UX-A (Andrei's standing
// rule: no explainer text under titles): it sits behind an (i) beside the page title, passed as
// the header's badge, and opens in a popover.
import { InfoTip } from "@companyos/ui";
import { useRouterState } from "@tanstack/react-router";
import type { ReactNode } from "react";
import { personalPageOf, setupPageOf } from "./setup-catalog";

/** The description of the page at `pathname`, or undefined. */
export function describePage(pathname: string): string | undefined {
  const m = /^\/c\/[^/]+\/setup\/(.+)$/.exec(pathname);
  if (m?.[1]) return setupPageOf(m[1])?.description;
  return personalPageOf(pathname)?.description;
}

/** The (i) beside a Setup page's title; nothing when the catalog has no description. */
export function SetupDescription(): ReactNode {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const text = describePage(pathname);
  if (!text) return null;
  return (
    <span data-slot="setup-description" className="inline-flex">
      <InfoTip label="About this page">{text}</InfoTip>
    </span>
  );
}

/** A header badge with the page's (i) after it (`badge` first, when there is one). */
export function withSetupDescription(badge?: ReactNode): ReactNode {
  return (
    <span className="inline-flex items-center gap-1">
      {badge}
      <SetupDescription />
    </span>
  );
}
